"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DVLGroupSection = void 0;
const lib_palette_1 = __importDefault(require("@opsbase/lib-palette"));
const web_css_1 = __importDefault(require("@opsbase/web-css"));
const useDataTree_1 = __importDefault(require("@opsbase/web-ctrl-datatree/useDataTree"));
const useView_1 = __importDefault(require("@opsbase/web-ctrl-view/useView"));
const Vertical_1 = __importDefault(require("@opsbase/web-layout/Vertical"));
const react_1 = __importStar(require("react"));
const calcIsExpanded_1 = __importDefault(require("../helpers/calcIsExpanded"));
const makeMyClasses = () => ({
    root: {
        borderBottom: `1px solid ${lib_palette_1.default.LineGrey.main}`,
    },
    childContainer: {
        position: 'relative',
    },
});
function DVLGroupSection(props) {
    var _a;
    const { nodeKey, children, component: Component } = props;
    const dt = (0, useDataTree_1.default)();
    const view = (0, useView_1.default)(dt.viewId);
    const node = dt.nodesByKey.get(nodeKey);
    const isRoot = node === dt.rootNode;
    const isHighlighting = !!((_a = view.highlightedGroups) === null || _a === void 0 ? void 0 : _a.length);
    const totalCount = dt.totalCountForNode.get(node) || 0;
    const isEmpty = totalCount === 0;
    const isHidden = (isHighlighting && !node.highlighted) || (view.hideEmptyGroups && !isRoot ? isEmpty : false);
    const isExpanded = (0, calcIsExpanded_1.default)(view, node);
    const myCss = (0, web_css_1.default)(makeMyClasses);
    return (0, react_1.useMemo)(() => {
        if (isHidden)
            return null;
        if (isRoot) {
            return react_1.default.createElement(Vertical_1.default, null, children);
        }
        return (react_1.default.createElement("div", { className: myCss.root },
            react_1.default.createElement(Component, { nodeKey: nodeKey }),
            !isEmpty && isExpanded && react_1.default.createElement("div", { className: myCss.childContainer }, children)));
    }, [Component, children, isEmpty, isExpanded, isHidden, isRoot, myCss, nodeKey]);
}
exports.DVLGroupSection = DVLGroupSection;
exports.default = DVLGroupSection;
